import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'ఈ పేజీని నివేదించండి',
  title: 'ఈ పేజీలో ఉన్న సమస్యను నివేదించండి',
  reasons: {
    'inaccurate-or-fabricated': 'తప్పు లేదా కల్పిత సమాచారం',
    'wrong-product': 'ఉత్పత్తులు పేజీకి సరిపోలడం లేదు',
    'sexually-explicit': 'లైంగిక అసభ్య కంటెంట్',
    'regulated-product': 'ప్రిస్క్రిప్షన్ లేదా నియంత్రిత ఉత్పత్తి',
    'dangerous-product': 'ప్రమాదకరమైన ఉత్పత్తి',
    'ip-infringement': 'నా హక్కులను ఉల్లంఘిస్తోంది (ట్రేడ్‌మార్క్/కాపీరైట్)',
    other: 'ఇంకేదైనా',
  },
  detail: 'వివరాలు (ఐచ్ఛికం)',
  submit: 'నివేదిక పంపండి',
  cancel: 'రద్దు చేయండి',
  sent: 'ధన్యవాదాలు. నివేదికలను 24 గంటల్లోపు సమీక్షిస్తాము.',
  failed: 'నివేదికను పంపలేకపోయాము. దయచేసి మళ్లీ ప్రయత్నించండి.',
};
